export default "__VITE_ASSET__5c9bc4d3__"